export const MARGIN_3XL = "96px";
export const MARGIN_4XL = "120px";
export const MARGIN_LG = "36px";
export const MARGIN_MD = "24px";
export const MARGIN_SM = "12px";
export const MARGIN_XL = "48px";
export const MARGIN_XS = "6px";
export const MARGIN_XXL = "72px";
export const MARGIN_XXS = "2px";
export const BLUEBERRY_0 = "#E6ECF5";
export const BLUEBERRY_1 = "#B7C6E6";
export const BLUEBERRY_2 = "#385A9D";
export const BLUEBERRY_3 = "#03184E";
export const CARROT_0 = "#FFF4F1";
export const CARROT_1 = "#FFD9CC";
export const CARROT_2 = "#f2674b";
export const CARROT_3 = "#D2563D";
export const CHARCOAL_0 = "#c2c3c5";
export const CHARCOAL_1 = "#969799";
export const CHARCOAL_2 = "#717377";
export const CHARCOAL_3 = "#39383C";
export const CHICKPEA_0 = "#FFFAF3";
export const CHICKPEA_1 = "#fff3e1";
export const CHICKPEA_2 = "#f2e1c8";
export const CHICKPEA_3 = "#D3BFA2";
export const ERROR_RED = "#f54c5a";
export const KALE_0 = "#E5EFE7";
export const KALE_1 = "#b5d3ba";
export const KALE_2 = "#417C67";
export const KALE_3 = "#173b33";
export const OYSTER_0 = "#F6F5F3";
export const OYSTER_1 = "#EFEDEA";
export const OYSTER_2 = "#DBD6D1";
export const OYSTER_3 = "#C6BFB7";
export const TFD_LOGO = "#F5694D";
export const WHITE = "#ffffff";
export const FACEBOOK = "#3b5998";
export const INSTAGRAM = "#6ba5d5";
export const TWITTER = "#1da1f2";
export const LG = "1024px";
export const MD = "710px";
export const SM = "375px";
export const XL = "1400px";
export const XS = "0px";
export const ANIMATION_STANDARD = "300ms ease-in-out";
export const ANIMATION_STANDARD_TIMING_FUNCTION = "ease-in-out";
export const ANIMATION_STANDARD_DURATION = "300ms";
export const PAGE_MARGIN_XS = "10px";
export const PAGE_MARGIN_SM = "30px";
export const PAGE_MARGIN_MD = "auto";
export const PAGE_MARGIN_LG = "40px";
export const PAGE_MARGIN_XL = "auto";
export const GUTTER_LG = "20px";
export const GUTTER_XL = "30px";
export const COLUMN_XS = "100%";
export const COLUMN_SM = "100%";
export const COLUMN_MD = "100%";
export const COLUMN_LG = "300px";
export const COLUMN_XL = "375px";
export const GRID_COLUMN_GAP_SM = "12px";
export const GRID_COLUMN_GAP_MD = "24px";
export const BLACK = "#000000";
export const BLUE = "#4141a5";
export const PALE_RED = "#d64c4c";
export const PALE_SALMON = "#ffb3a2";
export const PINKISH_ORANGE = "#ff764d";
export const SALMON = "#ff8d6a";
export const SILVER = "#d0d1d1";
export const SLATE_GREY = "#5b5e62";
export const VERY_LIGHT_PINK = "#f9f4ee";
export const VERY_LIGHT_PINK_TWO = "#fcfaf6";
export const WEIRD_GREEN = "#4cd6a4";
export const WHITE_TWO = "#f9f9f9";
export const TFD_ARTICLE_20_LINE_HEIGHT = "32px";
export const TFD_ARTICLE_16_LINE_HEIGHT = "26px";
export const TFD_ARTICLE_12_LINE_HEIGHT = "20px";
export const TFD_HEADING_72_LINE_HEIGHT = "84px";
export const TFD_HEADING_52_LINE_HEIGHT = "62px";
export const TFD_HEADING_40_LINE_HEIGHT = "48px";
export const TFD_HEADING_28_LINE_HEIGHT = "34px";
export const TFD_HEADING_22_LINE_HEIGHT = "30px";
export const TFD_HEADING_16_LINE_HEIGHT = "22px";
export const TFD_HEADING_12_LINE_HEIGHT = "18px";
export const TFD_DYNAMIC_BOLD_HEADING = "900";
export const TFD_DYNAMIC_BOLD_HEADING_VALUE = 900;
export const TFD_LISTSELECT_BADGE_PADDING = "3px var(--margin-sm)";
export const Z_INDEX_MODAL = "1000000";
export const Z_INDEX_MODAL_VALUE = 1000000;
export const Z_INDEX_APP_BAR = "9001";
export const Z_INDEX_APP_BAR_VALUE = 9001;
export const BORDER_LABEL_TEXT_OFFSET = "4px";
export const BORDER_LABEL_PADDING = "12px";
export const BORDER_LABEL_HEIGHT = "50px";
export const BORDER_LABEL_RADIUS = "4px";
export const CHECKBOX_INPUT_SIZE = "26px";
export const MODAL_TOP_PADDING = "58px";
export const MODAL_TOP_PADDING_LG = "80px";
export const RADIO_INPUT_SIZE = "32px";
export const ARTICLE = "tiempos, serif";
export const BODY = "neue-haas-grotesk-text, sans-serif";
export const HEADING_SANS = "neue-haas-grotesk-display, sans-serif";
